import axios from "axios";
const request = axios.create({
  withCredentials: false,
  // baseURL:'/api',
});
const LowcodeCenterRequest = axios.create({
  withCredentials: false,
  baseURL: "https://lowcode.linkgie.com/",
  // baseURL: "http://localhost:8090/",
});

const LowcodeCenter = {
  request: LowcodeCenterRequest
};

Object.freeze(LowcodeCenter);


const requestHandle = (config) => {
  // 判断是否有自定义的配置
  if (window.httpConfig) {
    let _config = window.httpConfig(config);
    if (_config) {
      config = _config;
    }
  }
  console.log(config);
  return config;
};

const requestErrorHandle = (error) => {
  console.log("error", error);
  return Promise.reject(new Error(error).message);
};

const responseHandle = (response) => {
  return response.data;
};

const responseErrorHandle = (error) => {
  console.log("error", error);
  return Promise.reject(new Error(error).message);
};

/**
 * 请求拦截
 */
request.interceptors.request.use(
  requestHandle,
  requestErrorHandle
);

request.interceptors.response.use(
  responseHandle,
  responseErrorHandle
);

LowcodeCenterRequest.interceptors.request.use(
  requestHandle,
  requestErrorHandle
);

LowcodeCenterRequest.interceptors.response.use(
  responseHandle,
  responseErrorHandle
);



export default request;

export { LowcodeCenter };
